import React, { useContext } from "react";
import ShopButton from "./ShopButton"; // Assuming this is your button component
import { SystemContext } from "../context/SystemContext";
import { useNavigate } from "react-router-dom";
import HorizontalScroll from "./HorizontalScroll";
import cdn from "../utils/cdn";

const breakpoints = [390, 755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const FindYourVibe = ({ title = true, shopButton = true, containerStyles, toggleMenu, numColumns, scrollable }) => {
  const navigate = useNavigate();
  const { productVibes } = useContext(SystemContext);

  const gridLayout = {
    display: "grid",
    gridTemplateColumns: `repeat(${numColumns || 'auto-fill'}, minmax(120px, 1fr))`,
    gap: "5px",
    [mq[0]]: {
      gridTemplateColumns: `repeat(${numColumns || 'auto-fill'}, minmax(180px, 1fr))`,
    },
    [mq[1]]: {
      gridTemplateColumns: `repeat(${numColumns || '3'}, minmax(180px, 1fr))`,
    },
    marginBottom: scrollable ? "5px" : ""
  }

  return (
    <div css={{ ...styles.container, ...containerStyles }}>
      {title && (
        <h2 css={styles.title}>Find your vibe</h2>
      )}

      {/* Grid Layout */}
      <HorizontalScroll>
        <div css={gridLayout}>
          {productVibes.map((vibe) => (
            <div
              key={vibe.id}
              css={{
                ...styles.card,
                backgroundImage: `url(${cdn.image(vibe.homepage_image_url, { h: 500 })})`, // The Firestore image
                height: `${numColumns && numColumns <= 2 ? "186px" : "86px"}`,
                [mq[1]]: {
                  height: `${numColumns <= 2 ? "186px" : "236px"}`,
                  fontSize: `${numColumns <= 2 ? "1.4rem" : "1.75rem"}`,
                  lineHeight: `${numColumns <= 2 ? "1.4rem" : "1.75rem"}`,
                },
              }}
              onClick={() => {
                navigate("/product-category/" + vibe.categoryName);
                if (toggleMenu) {
                  toggleMenu();
                }
              }}
            >
              <span style={{ ...styles.name }}>{vibe.name}</span>
            </div>
          ))}
        </div>
      </HorizontalScroll>
      {/* Shop All Button */}
      {shopButton && (
        <ShopButton
          text="Shop All"
          theme="dark"
          onClick={() => {
            navigate("/shop");
          }}
          arrow={true}
          containerStyles={styles.shop.button}
          buttonStyle={styles.shop.text}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "20px 10px 0px 10px",
    textAlign: "center",
  },
  title: {
    color: "black",
    fontSize: "1.4rem",
    fontWeight: 700,
    textAlign: "left",
    paddingLeft: "5px",
    paddingBottom: "12px",
    [mq[1]]: {
      fontSize: "1.75rem",
    },
  },
  card: {
    width: "100%",
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "10px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    color: "white",
    fontSize: "1.4rem",
    lineHeight: "1.1rem",
    fontWeight: 700,
    overflow: "hidden",
    cursor: "pointer",
  },
  name: {
    color: "white",
    fontWeight: 800,
    position: "absolute",
    bottom: 5,
    left: 5,
    textAlign: "left",
    whiteSpace: "normal", // Allows wrapping
    wordBreak: "break-word", // Ensures word breaks if necessary
    width: "90%",
  },
  shop: {
    button: {
      maxWidth: "380px",
      margin: "10px auto",
    },
    text: {
      fontSize: "1rem",
      lineHeight: "1rem",
      [mq[1]]: {
        fontSize: "1.25rem",
        lineHeight: "1.25rem",
      },
    }
  }
};

export default FindYourVibe;
